import React, { useEffect } from "react";
import { Routes, Route } from "react-router-dom";
import useAuthHandler from "../hooks/use-auth-handler";
import { useStore } from "../store/store.context";
import { setStoreUpdater } from "../hooks/useAuth";
import routes from "./routes";
import PrivateRoute from "./private-route";
import AppLayout from "../layout/app-layout";

const  AppRoutes = () => {
  const { updateStore } = useStore();
  
  useAuthHandler();

  // Set up the store updater for the useAuth hook
  useEffect(() => {
    setStoreUpdater(updateStore);
  }, [updateStore]);

  return (
    <Routes>
      {routes.map(({ path, element, requiresAuth }) => (
        <Route
          key={path}
          path={path}
          element={
            requiresAuth ? (
              <PrivateRoute>
                <AppLayout>{element}</AppLayout>
              </PrivateRoute>
            ) : (
              element
            )
          }
        />
      ))}
    </Routes>
  );
};

export default AppRoutes;
